<template>
  <div class="root-background">
    <div class="content">
      <div class="container">
        <div class="main-content-row delivery">
          <div class="delivery-brief">
            <div class="wrapper_left" style="width: 100%">
              <div class="search-div">
                <div>
                  <div class="CodeMirror">
                    <textarea class="textarea" v-model="clientNo"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="btn"><!-- @click="search"-->
              <button class="primary-button">查询(TRACK)</button>
<span class="txt" v-if="tipVisiable">{{tipMsg}}</span>
            </div>
          </div>
        </div>
        <div class="main-content-row delivery" v-if="infoVisiable">
          <div class="delivery-brief">
            <div class="delivery-content">
              <span>运单号 : {{order.findOrderResponse.clientNo}}</span>
              <span>订单号 : {{order.findOrderResponse.orderNo}}</span>
              <span>转单号 : {{order.findOrderResponse.enLogno}}</span>
              <span>件重体 : {{order.findOrderResponse.realCtn}}件 / {{order.findOrderResponse.realKg}}kg / {{order.findOrderResponse.realCbm}}cbm</span>
            </div>
            <div class="delivery-content">
              <span>地址 : {{order.findOrderResponse.shipmentCode}}/{{order.findOrderResponse.shipmentZip}}</span>
              <span>国家 : {{order.findOrderResponse.shipmentCountry}}</span>
              <span>州 : {{order.findOrderResponse.shipmentState}}</span>
              <span>下单时间 : {{order.findOrderResponse.createTime | dateformat}}</span>
            </div>
          </div>
          <div class="delivery-detail">
            <ul class="tab-details">
              <li class="status-updates">
                <div class="status-update-box">
                  <template v-for="(item,index) in order.findOrderLogisticsResponseList">
                  <div class="status-update-tab" :key="item.id">{{item.createTime | dateformat('MM-DD HH:mm')}}</div>
                  <div class="statusToggle" :key="index">
                    <span class="status-update">{{item.content}}</span>
                  </div>
                  </template>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import httpApi from '@/http/api'
export default {
  data() {
    return {
      clientNo: '',
      tipVisiable: false,
      tipMsg: '',
      infoVisiable: false,
      order: null
    }
  },
  methods: {
    // 查询物流信息
    async search() {
      this.tipVisiable = false
      this.infoVisiable = false
      this.order = null
      if (this.clientNo == null || this.clientNo.trim() === '') {
        this.tipMsg = '请输入运单号'
        this.tipVisiable = true
        return
      }
      const { data: res } = await httpApi.search({
        params: {
          clientNo: this.clientNo
        }
      })
      if (res.code === 'ok') {
        this.order = res.data
        this.infoVisiable = true
      } else {
        this.tipMsg = res.message
        this.tipVisiable = true
      }
    }
  },
  created() {
    //this.clientNo = this.$route.params.clientNo
    this.clientNo = this.$route.query.a
    if (this.clientNo != null && this.clientNo.trim() !== '') {
      this.search()
    }
  }
}
</script>
<style lang="less" scoped>
.root-background {
  background-color: #f2f2f2;
  background-position: 50% 25%;
  background-repeat: no-repeat;
  background-attachment: fixed;
  font-size: 13px;
  line-height: 1.42857;
  color: #333;
  // min-width: 1280px;
}

.content {
  color: #333;
  // min-height: 700px;
  padding: 55px 0;
}

.container {
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
  width: 800px;
}

.main-content-row {
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  margin-bottom: 14px;
  position: relative;
}

.delivery .delivery-brief {
  padding: 20px 55px;
  position: relative;
}
.delivery-detail {
    padding: 0 55px;
}

.search-div {
  border: #d8ded9 3px solid;
  border-radius: 4px;
  margin-bottom: 12px;
}

.CodeMirror {
  height: 150px;
  border-bottom: 1px solid #eaeaea;
}

.CodeMirror .textarea {
  height: 99.6%;
  width: 99.8%;
  resize: none;
  font-size: 25px;
}

.CodeMirror .btn {
  clear: both;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
}
.txt {
  color: red;
  margin-left: 10px;
}

.primary-button {
  color: #fff;
  background-color: #eb1d21;
  line-height: 30px;
  padding: 0;
  padding-left: 2px;
  width: 118px;
  font-size: 14px;
  letter-spacing: 2px;
  border-radius: 3px;
  text-align: center;
  border: 1px solid #b51919;
  position: relative;
  -webkit-transition: top 0.2s;
  transition: top 0.2s;
  top: 0;
  cursor: pointer;
}

.delivery-brief {
  padding: 20px 55px;
  position: relative;
}

.delivery-brief .delivery-content{
  line-height: 38px;
  font-size: 14px;
}

.delivery-brief .delivery-content span + span {
  margin-left: 20px;
}
.root-background delivery-detail {
  position: relative;
  padding: 0px 50px 20px;
}

.delivery-detail ul.tab-details {
  margin: 0;
}

.root-background .delivery-detail .tab-details > li.status-updates {
  list-style: none;
  margin: 5px;
}

.status-updates .status-update-box {
  margin-bottom: 5px;
}

.root-background
  .delivery-detail
  .tab-details
  .status-updates
  .status-update-box
  .status-update-tab {
  background-color: #f6f6f6;
  padding: 5px 25px;
  font-size: 14px;
  color: #333;
  position: relative;
  margin: 0 0 5px;
  border-left: 5px solid #f00;
}
.statusToggle .status-update {
  margin-left: 30px;
  margin-bottom: 5px;
  display: inline-block;
}
</style>
